import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const getTravelTypeSlice = createSlice({
  name: "getTravelType",
  initialState,
  reducers: {
    getTravelTypeStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    getTravelTypeSuccess(state, action) {
      state.loading = false;
      const flattenedArray = []?.concat(...action?.payload);
      state.data = flattenedArray;
      state.message = action.payload.message;
    },
    getTravelTypeFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  getTravelTypeStart,
  getTravelTypeSuccess,
  getTravelTypeFailure,
  clearError,
  clearMessage,
} = getTravelTypeSlice.actions;

export default getTravelTypeSlice.reducer;
